<template>
    <ac-modal :title="'FAQ\'s'" ref="modal">
        <template>
            <p><span style="font-weight:bold">Question</span>: How do I search by "Provider Type"? What are the
                different types of physicians available on the Accresa network?</p>

            <p>
                <span style="font-weight:bold">Answer</span>: Depending on the network and providers made available
                by your employer, you may be able to choose from a number of different types of healthcare providers
                - ranging from Doctor of Medicine (MD) to Nurse Practitioner (NP).
                The Provider Type search feature is an optional field that helps employees quickly narrow their
                search criteria. To view a partial list of common medical abbreviations, click
                <a target="_blank"
                   href=" https://www.fda.gov/downloads/Drugs/GuidanceComplianceRegulatoryInformation/UCM297632.pdf">
                    here
                </a>
            </p>
        </template>
    </ac-modal>
</template>

<script>
    import AcModal from "../../../global/customHtmlElements/AcModal.vue";

    export default {
        name: "FaqModal",
        components: {AcModal},
        methods: {
            showModal() {
                this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>

</style>